import * as Yup from 'yup'
import moment from 'moment'

const workExperienceShapeSchema = {
  title: Yup.string().when('isSaveAndExit', {
    is: undefined,
    then: Yup.string().required('Required'),
  }),
  employer: Yup.string().when('isSaveAndExit', {
    is: undefined,
    then: Yup.string().required('Required'),
  }),
  startDate: Yup.mixed().when('isSaveAndExit', {
    is: undefined,
    then: Yup.mixed().required('Required'),
  }),
  isCurrentEmployer: Yup.mixed().when('isSaveAndExit', {
    is: undefined,
    then: Yup.boolean(),
  }),
  endDate: Yup.mixed().when('isSaveAndExit', {
    is: undefined,
    then: Yup.mixed().when('isCurrentEmployer', {
      is: true,
      then: Yup.array().notRequired().nullable(),
      otherwise: Yup.string()
        .test('is-greater', 'Work Experience end date should be greater than start date', function (value) {
          const { startDate } = this.parent
          return moment().diff(moment(value), 'days') <= moment().diff(moment(startDate), 'days')
        })
        .required('Required'),
    }),
  }),
  description: Yup.mixed().when('isSaveAndExit', {
    is: undefined,
    then: Yup.string().required('Required').max(850, 'Your description must be fewer than 850 characters.'),
    otherwise: Yup.string().nullable(),
  }),
}

export const validationSchema = Yup.object().shape({
  workExperiences: Yup.array().of(Yup.object().shape(workExperienceShapeSchema)),
})
